module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAOBAMAAAARcxsoAAAAGFBMVEUAAAAeHh4YGBgaGhoYGBgZGRkZGRkZGRnHB9HpAAAACHRSTlMAEVV3iJm7zC4zhAMAAAAoSURBVAjXY2BgYFAAYuYAIGGKzGAFMUKBmCEZRIgbgMhgEMGKznQAAIOSA9XMEABOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/back.png
// module id = 669
// module chunks = 0